import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import ChatMessage from "@/views/ChatMessage/ChatMessage.vue";
import { isCompactMode } from "@/data/pubilc";
import { chatList } from "@/views/Home/useData/module/chat";
import ChatCover from "@/components/Dialogues/Chat/ChatCover.vue";

import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { watch } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatContent',
  setup(__props) {

const { isLogin } = storeToRefs(publicStore());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base", { 'compact-base': _unref(isCompactMode) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(chatList).length === 0 || !_unref(isLogin))
        ? (_openBlock(), _createBlock(ChatCover, { key: 0 }))
        : (_openBlock(), _createBlock(ChatMessage, { key: 1 }))
    ])
  ], 2))
}
}

})